import React from 'react';
import {BrowserRouter, Routes, Route, useLocation} from 'react-router-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import './App.css';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import About from './components/About/About';
import History from './components/History/History';
import Hero from './components/Hero/Hero';
import Map from './components/Map/Map';
import Footer from './components/Footer/Footer';

function AppContent() {
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';
  const isConferenceMapPage = location.pathname === '/conference-map';

  return (
    <div className="App">
      <Header />
      {!isAboutPage && !isConferenceMapPage && <Hero />}
      {!isAboutPage && !isConferenceMapPage && <Map />}
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path='/about' element={<About />}/>
        <Route path='/history' element={<History />} />
        <Route path='/conference-map' element={<Map />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
